var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1318 2V0H16.124V2H4.03101V0H3.02325V2H0V18H20.155V2H17.1318ZM3.02325 3V4H4.03101V3H16.124V4H17.1318V3H19.1473V6H1.00775V3H3.02325ZM1.00775 7V17H19.1473V7H1.00775Z",
    fill: "#6D838F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04652 11H3.02325V8H6.04652V11ZM5.03876 9H4.03101V10H5.03876V9Z",
    fill: "#6D838F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0775 11H7.05426V8H10.0775V11ZM9.06976 9H8.06201V10H9.06976V9Z",
    fill: "#6D838F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1085 11H11.0853V8H14.1085V11ZM13.1008 9H12.093V10H13.1008V9Z",
    fill: "#6D838F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1395 11H15.1163V8H18.1395V11ZM17.1318 9H16.124V10H17.1318V9Z",
    fill: "#6D838F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04652 15H3.02325V12H6.04652V15ZM5.03876 13H4.03101V14H5.03876V13Z",
    fill: "#6D838F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0775 15H7.05426V12H10.0775V15ZM9.06976 13H8.06201V14H9.06976V13Z",
    fill: "#6D838F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1085 15H11.0853V12H14.1085V15ZM13.1008 13H12.093V14H13.1008V13Z",
    fill: "#6D838F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1395 15H15.1163V12H18.1395V15ZM17.1318 13H16.124V14H17.1318V13Z",
    fill: "#6D838F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.ed44c1730743eb2ffc3dcc949ffe59d9.svg";